export default function makeCalcAppHeight () {
    /**
     * Updates the page height to be used on the SCSS.
     */
    const calcAppHeight = () => {
        const doc = document.documentElement;
        doc.style.setProperty('--app-height', `${window.innerHeight}px`);
    };
    calcAppHeight();

    window.addEventListener('resize', () => calcAppHeight());
};
